export class Promocao {
  id: number;
  titulo: string;
  imagem$: Promise<Promise<string>>;
  imagem: string;
  imagemRegulamento: string;
  imagemRegulamento$: Promise<Promise<string>>;
  dataInicio: Date;
  dataFim: Date;
  data: Date;
  classificacoes: number[];
  buscouImagem: boolean;
  ativo: boolean;
  idProduto?: number;
  nomeProduto: string;
  campanha: boolean;
  tipoCampanha: number;
}
